import React, { useEffect, useState } from 'react';
import { Collapse, Row, Col } from 'antd';
import { cssStringToObj } from '../../api/Util';
import RenderHtml from '../common/RenderHtml';
import "./AnnouncementBannerStyle.scss"

const { Panel } = Collapse;

const AnnouncementBanner = ({ showBanner, headingStyle, bannerTextStyle, bodyFontStyle, auth }) => {
    const storageKey = `announcement_expanded_${auth?.client_id}`;
    const [activeKey, setActiveKey] = useState(null); // start with null to avoid flicker

    useEffect(() => {
        const isClosed = localStorage.getItem(storageKey);
        if (isClosed === 'true') {
            setActiveKey([]); // closed
        } else {
            setActiveKey(['1']); // open by default
        }
    }, [storageKey]);

    const handleCollapseChange = (keys) => {
        const isOpen = keys.includes('1');
        setActiveKey(isOpen ? ['1'] : []);
        localStorage.setItem(storageKey, isOpen ? 'false' : 'true');
    };

    if (activeKey === null) return null; // prevent initial flash

    return (
        <Collapse activeKey={activeKey} onChange={handleCollapseChange} style={{ margin: 0 }}>
            <Panel className="bg-warning announcement-banner-panel" header="📢 ANNOUNCEMENT" key="1">
                <Row style={{ margin: 0 }}>
                    <Col className="bg-warning  announcement-banner" span={24}>
                        <div style={headingStyle}>
                            <RenderHtml
                                bannerHeading={showBanner?.banner_heading}
                                bannerHeadingTag={showBanner?.banner_heading_style}
                                headingStyle={headingStyle}
                            />
                        </div>
                        <div style={bannerTextStyle}>
                            <p style={bodyFontStyle}>{showBanner?.banner_text || ""}</p>
                        </div>
                        {showBanner?.banner_image && (
                            <img
                                src={showBanner?.banner_image}
                                alt="Banner"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    ...cssStringToObj(showBanner?.banner_image_style)
                                }}
                            />
                        )}
                    </Col>
                </Row>
            </Panel>
        </Collapse>
    );
};

export default AnnouncementBanner;
